import React from 'react'
import { Switch } from 'react-router-dom'
import Route from './Route'

import SignIn from '../pages/SignIn'
import SignUp from '../pages/SignUp'
import PassRecoverGetCRM from '../pages/PassRecover/GetCRM'
import PassRecoverPasswordChange from '../pages/PassRecover/PasswordChange'
import MatriculaRecover from '../pages/MatriculaRecover'
import GrupoPermissoes from '../pages/UserViews/GrupoPermissoes'
import NotAllowed from '../pages/NotAllowed'
import Dashboard from '../pages/UserViews/Dashboard'
import Cadastro from '../pages/Cadastro'
import Perfil from '../pages/UserViews/Perfil'
import Relatorio from '../pages/UserViews/Relatorio'
import Gerenciamento from '../pages/UserViews/Gerenciamento'
import DadosCadastraisAssociado from '../pages/UserViews/EspacoMedico/DadosCadastrais'
import BuscaTalentos from '../pages/UserViews/Talentos/BuscaTalentos'
import PerfilTalento from '../pages/UserViews/Talentos/PerfilTalento'
import CargaTalentos from '../pages/UserViews/Talentos/Carga'
import ListarProjetos from '../pages/UserViews/Projetos/Listar'
import AcompanhamentoProjeto from '../pages/UserViews/Projetos/Acompanhamento'
import CadastroProjeto from '../pages/UserViews/Projetos/Cadastro'
import ValidacaoInstituicao from '../pages/UserViews/Instituicao/Validacao'
import TRL from '../pages/UserViews/Gerenciamento/TRL'
import AvaliadoresTRL from '../pages/UserViews/Gerenciamento/Avaliador'

export default function Routes() {
    return (
        <Switch>
            <Route path="/" exact component={SignIn} />

            <Route path="/not_allowed" component={NotAllowed} isPrivate />

            <Route path="/signup" component={SignUp} />
            <Route path="/pass_recover" exact component={PassRecoverGetCRM} />
            <Route path="/pass_recover/:token/:crm" component={PassRecoverPasswordChange} />
            <Route path="/matricula_recover" component={MatriculaRecover} />

            <Route path="/dashboard" component={Dashboard} isPrivate />
            <Route path="/perfil" component={Perfil} isPrivate exact />
            <Route path="/grupo_permissoes/:grupoId" component={GrupoPermissoes} isPrivate />

            <Route path="/relatorio/:grupoId" component={Relatorio} isPrivate />
            <Route path="/gerenciar/:entidade" component={Gerenciamento} isPrivate />

            <Route path="/associado/dados_cadastrais" component={DadosCadastraisAssociado} isPrivate />
            
            <Route path="/busca_talento" component={BuscaTalentos} isPrivate />
            <Route path="/carga_talento" component={CargaTalentos} isPrivate />
            
            <Route path="/perfil/:id" component={PerfilTalento} isPrivate />

            <Route path="/cadastro" component={Cadastro} />
            
            <Route path="/projetos/listar" component={ListarProjetos} isPrivate exact />
            <Route path="/projeto/cadastro" component={CadastroProjeto} isPrivate exact />
            <Route path="/projeto/:id" component={AcompanhamentoProjeto} isPrivate />
            
            <Route path="/instituicao/validacao" component={ValidacaoInstituicao} isPrivate />
            
            <Route path="/gerenciamento/trl" component={TRL} isPrivate />
            <Route path="/gerenciamento/avaliador" component={AvaliadoresTRL} isPrivate />
            
            <Route path="*" />
        </Switch>
    )
}
